var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagItl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0017 1H1V19H10.0017V1Z",
    fill: "#3D9348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0026 1H10.0039V19H19.0056V1H19.0026Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9987 1H19V19H27.9987V1Z",
    fill: "#D61E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagItl);
export default __webpack_public_path__ + "static/media/flagITL.21987413123b4c6890cd82e0ccdfbf1d.svg";
export { ForwardRef as ReactComponent };